import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import {
  weddingSupplierDetailQueryOptions,
  weddingSuppliersQueryOptions,
} from '@/features/suppliers/api'
import { SuppliersWorkspace } from '@/features/suppliers/pages/suppliers-workspace'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/suppliers/$weddingSupplierId')({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(weddingSuppliersQueryOptions(params.workspaceSlug)),
      context.queryClient.ensureQueryData(
        weddingSupplierDetailQueryOptions(params.workspaceSlug, params.weddingSupplierId),
      ),
    ])
  },
  component: WeddingSupplierRoute,
})
function WeddingSupplierRoute() {
  const { workspaceSlug, weddingSupplierId } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <SuppliersWorkspace
      workspaceSlug={workspaceSlug}
      selectedWeddingSupplierId={weddingSupplierId}
      canWrite={workspace.data?.role !== 'viewer'}
    />
  )
}
